import React, { useState, useEffect } from 'react';
import { FaSchool, FaGraduationCap, FaGlobe, FaTools, FaClipboardCheck, FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './ventajas.css';
import ModalCursos from '../cursos/modalcursos';
import { obtenerTodosProgramas } from '../../../funtions';
import carga from '../../carga/carga';

function Ventajas() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [cursosCargados, setCursosCargados] = useState([]);
  const navigate = useNavigate();

  // Cargar programas desde Firestore
  useEffect(() => {
    const loadPrograms = async () => {
      try {
        carga.mostrarCarga();
        const programas = await obtenerTodosProgramas();
        const basicProgramas = programas.map(p => ({
          id: p.id,
          nombre: p.nombre,
          descripcion: p.descripcion,
          cardPrincipal: p.cardPrincipal,
          categoria: p.categoria,
        }));
        setCursosCargados(basicProgramas);
      } catch (error) {
        console.error('Error cargando programas:', error);
      } finally {
        carga.ocultarCarga();
      }
    };

    loadPrograms();
  }, []);

  const openModal = (courseId) => {
    setSelectedCourseId(courseId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedCourseId(null);
  };

  const scrollToSection = (id) => {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const courses = [
    {
      icon: FaSchool,
      title: 'Convalidación Primaria',
      subtitle: [],
      description: 'Educación en solo 6 meses. Flexible, personalizada y a tu ritmo.',
      codigo: 'CV-PRIM-001',
      image: 'https://ensenarteonline.com.co/images/covalidacionprimaria.png',
      showButton: true
    },
    {
      icon: FaGraduationCap,
      title: 'Convalidación Bachillerato',
      subtitle: [],
      description: 'Obtén tu título en solo 6 meses con una educación flexible, personalizada y a tu ritmo.',
      codigo: 'CV-BACH-001',
      image: 'https://ensenarteonline.com.co/images/covalidacionbachillerato.png',
      showButton: true
    },
    {
      icon: FaHome,
      title: 'Home School Primaria',
      subtitle: [],
      description: 'Estudia con horarios flexibles, clases en vivo, acompañamiento académico y acceso 24/7 para continuar tu formación.',
      codigo: 'HS-PRIM-001',
      image: 'https://ensenarteonline.com.co/images/homeschoolprimariav2.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaHome,
      title: 'Home School Bachillerato',
      subtitle: [],
      description: 'Estudia con horarios flexibles, clases en vivo, acompañamiento académico y acceso 24/7 para continuar tu formación.',
      codigo: 'HS-BACH-001',
      image: 'https://ensenarteonline.com.co/images/homeschoolbachilleratov2.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    
    {
      icon: FaTools,
      title: 'Cursos libres técnicos laborales',
      subtitle: [],
      description: 'Cursos Libres con Certificación. Formación complementaria en áreas clave de los programas.',
      codigo: 'CURSOS-TEC-001',
      image: 'https://ensenarteonline.com.co/images/tecnicoslaborales.png',
      showButton: true,
      buttonText: 'Ver más',
      navigateTo: '/tecnicoslaborales'
    },{
      icon: FaGlobe,
      title: 'Cursos de Idiomas',
      subtitle: [],
      description: 'Cursos de idiomas con certificación internacional. Desde nivel básico hasta avanzado.',
      codigo: 'CURSOS-IDI-001',
      image: 'https://ensenarteonline.com.co/images/cursosidiomas.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaClipboardCheck,
      title: 'Cursos Libres',
      subtitle: [],
      description: 'Excel Básico, Excel Intermedio, Excel Avanzado, Pre-icfes virtual y presencial.',
      codigo: 'EXC-2026-HME',
      image: 'https://ensenarteonline.com.co/images/excel.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaGraduationCap,
      title: 'Programa de Inteligencia Artificial (IA)',
      subtitle: [],
      description: 'Fundamentos de IA, machine learning y análisis de datos.',
      codigo: 'IA-PROG-001',
      image: 'https://ensenarteonline.com.co/images/inteligencia.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaGraduationCap,
      title: 'Programa de Manipulacios de alimentos',
      subtitle: [],
      description: 'Fundamentos de inocuidad, buenas prácticas y control seguro de alimentos.',
      codigo: 'PROG-ALI-001',
      image: 'https://ensenarteonline.com.co/images/alimentos.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaGraduationCap,
      title: 'Programa de capacitación de empresas',
      subtitle: [],
      description: 'Capacitación personalizada para empresas, adaptada a sus necesidades específicas.',
      codigo: 'PROG-EMP-001',
      image: 'https://ensenarteonline.com.co/images/capempresa.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaGraduationCap,
      title: 'Programa de capacitación de colegios',
      subtitle: [],
      description: 'Capacitación personalizada para colegios, adaptada a sus necesidades específicas.',
      codigo: 'PROG-COL-001',
      image: 'https://ensenarteonline.com.co/images/capcolegios.png',
      showButton: true,
      buttonText: 'Ver más'
    },
    {
      icon: FaGraduationCap,
      title: 'Programa de Pre-icfes',
      subtitle: [],
      description: 'Preparación integral para el examen de estado, con enfoque en áreas clave y estrategias de estudio efectivas.',
      codigo: 'PROG-ICFES-001',
      image: 'https://ensenarteonline.com.co/images/preicfes.png',
      showButton: true,
      buttonText: 'Ver más'
    }
  ];

  return (
    <section id="cursos" className="advantages-section section-animated">
      <div className="advantages-container">
        <h2 className="advantages-title">¿POR QUÉ FORMARSE CON NOSOTROS?</h2>
        <p className="advantages-subtitle-main">Formación práctica, rápida y 100% convalidadas para avanzar en tu carrera profesional desde el primer día.</p>
        <div className="advantages-grid">
          {courses.map((course, index) => {
            const Icon = course.icon;
            const hasImage = Boolean(course.image);
            return (
              <article
                key={index}
                className={`advantage-card ${hasImage ? 'has-image' : 'no-image'} ${activeIndex === index ? 'active' : ''}`}
                onMouseEnter={hasImage ? () => setActiveIndex(index) : undefined}
                onMouseLeave={hasImage ? () => setActiveIndex(null) : undefined}
                onClick={hasImage ? () => setActiveIndex(activeIndex === index ? null : index) : undefined}
                style={hasImage ? { backgroundImage: `url(${course.image})` } : undefined}
              >
                {hasImage ? (
                  <div className="advantage-card-overlay">
                    <div className="advantage-card-content">
                      <div className="advantage-icon"><Icon size={32} /></div>
                      <h3>{course.title}</h3>
                      <div className="advantage-subtitle">
                        {course.subtitle.map((text, idx) => (
                          <p key={idx}>{text}</p>
                        ))}
                      </div>
                      <p className="advantage-description">{course.description}</p>
                      {course.showButton && (
                        <button className="advantage-button" onClick={(e) => { e.stopPropagation(); course.navigateTo ? navigate(course.navigateTo) : openModal(course.codigo); }}>Ver más</button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="advantage-card-content no-image">
                    <div className="advantage-icon"><Icon size={32} /></div>
                    <h3>{course.title}</h3>
                    <div className="advantage-subtitle">
                      {course.subtitle.map((text, idx) => (
                        <p key={idx}>{text}</p>
                      ))}
                    </div>
                    <p className="advantage-description">{course.description}</p>
                    {course.showButton && (
                      <button className="advantage-button" onClick={(e) => { e.stopPropagation(); course.navigateTo ? navigate(course.navigateTo) : openModal(course.codigo); }}>Ver más</button>
                    )}
                  </div>
                )}
              </article>
            );
          })}
        </div>

        <div className="advantages-extra">
          <p>Ver todos nuestros cursos, obtener más info.</p>
          <button className="advantages-see-all" onClick={() => navigate('/tecnicoslaborales')}>Ver todos los cursos</button>
        </div>

        <div className="advantages-scholarship">
          <p><strong>Becas desde el 50% hasta el 85%</strong> ¡Únete hoy!</p>
          <p>Todos nuestros programas cuentan con registro SNIES y SIET ante el Ministerio de Educación Nacional.</p>
        </div>
      </div>

      {/* Modal separado */}
      <ModalCursos 
        isOpen={modalOpen} 
        courseId={selectedCourseId} 
        onClose={closeModal} 
      />
    </section>
  );
}

export default Ventajas;
